import { render, staticRenderFns } from "./WQDataRecordList.vue?vue&type=template&id=174fd2a6&scoped=true"
import script from "./WQDataRecordList.vue?vue&type=script&lang=js"
export * from "./WQDataRecordList.vue?vue&type=script&lang=js"
import style0 from "./WQDataRecordList.vue?vue&type=style&index=0&id=174fd2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174fd2a6",
  null
  
)

export default component.exports